import { Component, OnInit, Input, EventEmitter, Output, OnDestroy } from '@angular/core';
import { Router, NavigationStart, ActivatedRoute, NavigationEnd } from "@angular/router";
import { Location } from '@angular/common';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { UsersTableComponent } from '../../pages/users/users-table/users-table.component';
import { UsersService } from 'src/app/shared/services/users.service';
import { ConsentService } from '../../shared/services/consent.service';
import { ComponentName } from 'src/app/Enum/usersFilterEnums';

@Component({
  selector: 'app-confirmation-modal',
  templateUrl: './confirmation-modal.component.html',
  styleUrls: ['./confirmation-modal.component.less']
})
export class ConfirmationModalComponent implements OnInit {

  @Input()
  public buttonsTitle = {
    dismiss: 'Cancel',
    confirm: null,
    component: null
  };

  @Input() public description: string;
  @Input() public title: string;
  @Output() clikedonConfirm = new EventEmitter();
  constructor(private _router: Router, public modalRef: BsModalRef,
    private _location: Location, private usersService: UsersService,
    private consentService:ConsentService) {
  }
  ngOnInit() {
  }

  clikedonConfirmation(val) {

    if (val.target.textContent == "Reset") {
      if (this.buttonsTitle.component == ComponentName.Users) {
        if (this.usersService.resetFilters.observers.length > 0) {
          this.usersService.resetFilters.next();
        }
        else {
          this.usersService.resetHeaders.next();
        }
      }
    
      this.modalRef.hide();
    }
    else if (val.target.textContent == "Delete") {
      if (this.buttonsTitle.component == ComponentName.Users) {
        this.usersService.deleteUser.next();
      }
     
      this.modalRef.hide();
    }
  }

}
